export const keys = {
  Enter: 'Enter',
  ESC: 'Escape',
};
